import { render } from "./EditConfirmModalWithInputArea.vue?vue&type=template&id=781b6365"
import script from "./EditConfirmModalWithInputArea.vue?vue&type=script&lang=js"
export * from "./EditConfirmModalWithInputArea.vue?vue&type=script&lang=js"
script.render = render

export default script